import { Link } from 'react-router-dom';
import { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.image}
            alt={article.title}
            title={`${article.title} - 欧美专区`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <span className="inline-block px-2.5 py-1 text-xs font-label rounded-full bg-primary-500 text-background-50">
              {article.categoryName}
            </span>
          </div>
        </div>
        <div className="p-4">
          <h3 className="font-heading text-base font-semibold text-foreground-900 line-clamp-2 mb-2 group-hover:text-primary-600 transition-colors duration-200">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between text-xs text-foreground-400">
            <span>{article.author}</span>
            <div className="flex items-center gap-3">
              <span>{article.date}</span>
              <span>{article.readTime}</span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}